// components/ThemeMessageListener.tsx
import React from 'react';
import { useThemeMessageListener } from '../../hooks/useThemeMessageListener';

const ThemeMessageListener: React.FC = () => {
    useThemeMessageListener();
    return null; // This component doesn't render anything
};

export default ThemeMessageListener;